export const environment = {
  production: false,
  keycloak: {
    url: 'https://connect-staging-auth.oamarelinho.com.br',
    realm: 'sge',
    clientId: 'sge-client'
  },
  primeNgLicense: '',
  api: {
    baseUrl: 'https://mock.apidog.com/m1/1093204-1082952-default',
    // Habilitar quando baseUrl apontar para a API real do SGE.
    sendBearerToken: false
  }
};
